import { App } from '../features/home';
import { PageNotFound } from '../features/common';
import homeRoute from '../features/home/route';
import commonRoute from '../features/common/route';
import _ from 'lodash';
import loginRoute from '../features/login/route';
import registerRoute from '../features/register/route';
import phaseRoute from '../features/phase/route';
import memberRoute from '../features/member/route';
import wbsRoute from '../features/wbs/route';
import caRoute from '../features/ca/route';
import costRoute from '../features/cost/route';
import summaryRoute from '../features/summary/route';
import unitRoute from '../features/unit/route';
import currencyRoute from '../features/currency/route';
import dcRoute from '../features/dc/route';
import dailyRoute from '../features/daily/route';
import fileuploadRoute from '../features/fileupload/route';
import actualRoute from '../features/actual/route';
import completionRoute from '../features/completion/route';
import cirRoute from '../features/cir/route';
import periodsRoute from '../features/periods/route';
import profileRoute from '../features/profile/route';
import statusRoute from '../features/status/route';
import workplanRoute from '../features/workplan/route';
import companyRoute from '../features/company/route';

// NOTE: DO NOT CHANGE the 'childRoutes' name and the declaration pattern.
// This is used for Rekit cmds to register routes config for new features, and remove config when remove features, etc.
const childRoutes = [
  homeRoute,
  commonRoute,
  loginRoute,
  registerRoute,
  phaseRoute,
  memberRoute,
  wbsRoute,
  caRoute,
  costRoute,
  summaryRoute,
  unitRoute,
  currencyRoute,
  dcRoute,
  dailyRoute,
  fileuploadRoute,
  actualRoute,
  completionRoute,
  cirRoute,
  periodsRoute,
  statusRoute,
  profileRoute,
  workplanRoute,
  companyRoute,
];

const routes = [{
  path: '/',
  component: App,
  childRoutes: [
    ...childRoutes,
    { path: '*', name: 'Page not found', component: PageNotFound },
  ].filter(r => r.component || (r.childRoutes && r.childRoutes.length > 0)),
}];

// Handle isIndex property of route config:
//  Dupicate it and put it as the first route rule.
function handleIndexRoute(route) {
  if (!route.childRoutes || !route.childRoutes.length) {
    return;
  }

  const indexRoute = _.find(route.childRoutes, (child => child.isIndex));
  if (indexRoute) {
    const first = { ...indexRoute };
    first.path = '';
    first.exact = true;
    first.autoIndexRoute = true; // mark it so that the simple nav won't show it.
    route.childRoutes.unshift(first);
  }
  route.childRoutes.forEach(handleIndexRoute);
}

routes.forEach(handleIndexRoute);
export default routes;



// WEBPACK FOOTER //
// ./src/common/routeConfig.js